import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ 
  title, 
  value, 
  change, 
  changeType = 'neutral',
  icon,
  trend = []
}) => {
  const changeColors = {
    positive: 'text-success',
    negative: 'text-error',
    neutral: 'text-muted-foreground'
  };

  const changeIcons = {
    positive: 'TrendingUp',
    negative: 'TrendingDown',
    neutral: 'Minus'
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-elevation-sm hover:shadow-elevation-md transition-base">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1 min-w-0">
          <p className="text-sm text-muted-foreground text-caption mb-1">{title}</p>
          <h3 className="text-2xl md:text-3xl font-semibold text-foreground font-heading truncate">
            {value}
          </h3>
        </div>
        <div className="bg-primary/10 p-2 md:p-3 rounded-lg flex-shrink-0 ml-3">
          <Icon name={icon} size={20} color="var(--color-primary)" />
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1">
          <Icon 
            name={changeIcons?.[changeType]} 
            size={16} 
            color={`var(--color-${changeType === 'positive' ? 'success' : changeType === 'negative' ? 'error' : 'muted-foreground'})`}
          />
          <span className={`text-sm font-medium ${changeColors?.[changeType]}`}>
            {change}
          </span>
        </div>
        
        {trend?.length > 0 && (
          <div className="flex items-end gap-0.5 h-6">
            {trend?.map((value, index) => (
              <div
                key={index}
                className="w-1 bg-primary/30 rounded-t"
                style={{ height: `${(value / Math.max(...trend)) * 100}%` }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricsCard;